import initialState from "./initialState";

export function AirlineInvoicingPeriodsReducer(
  state = initialState.AirlineInvoicingPeriods,
  action
) {
  switch (action.type) {
    case "AIRLINE_INVOICING_PERIODS_SELECTION_REQUEST":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
